import HasID from "./HasID";
import TrackedObject from "./TrackedObject";
import HasLabel from "./HasLabel";
import moment from "moment";

export interface PharmacyRecord extends HasID, TrackedObject {
    id: number;
    name: string;
    address: string;
    addressCity: string;
    addressState: string;
    addressZip: string;
    phoneNumber: string;
    faxNumber: string;
    npiNumber: string;
    storeNumber: string;
    dea: string;
    ncpdp: string;
    pharmacist: string;
    isActive: boolean;
    inNetwork: boolean;
    supportsTransferMyRx: boolean;
}

export class PharmacyRecord extends HasLabel {
    constructor(obj?: PharmacyRecord) {
        super();
        if (obj) Object.assign(this, obj);
    }

    toString(): string {
        if (!this.name) return "";

        const labelArray = [this.name];

        if (this.faxNumber) labelArray.push(`fax: ${this.faxNumber}`);
        if (this.phoneNumber) labelArray.push(`phone: ${this.phoneNumber}`);

        return labelArray.join(", ");
    }
}

export interface TransferRXRecord extends HasID, TrackedObject {
    id: number;
    storeId: number;
    rxNumber: number;
    rfNumber: number;
    patientName: string;
    drugName: string;
    isVerbalTransfer: boolean;
    storedPharmacyId: number;
    pharmacyName: string;
    transferredDate: Date;
    transferredBy: string;
    docFileName: string;
    pharmacyFax: string;
    transferMethod: string;
}

export class TransferRXRecord {
    constructor(obj?: TransferRXRecord) {
        if (obj) {
            Object.assign(this, obj);
            if (obj.transferredDate) this.transferredDate = moment.utc(obj.transferredDate).toDate();
        }
    }
}
